import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SlideImage } from '../ProceedTopUp.style';
import { Slide } from "react-slideshow-image";

const Container = styled.div`
   padding-top: 24px;

   .react-slideshow-container {
    border-radius: 16px;
    border: none;

    img {
        border-radius: 16px;
    }
   }

   .indicators {
    padding-inline-start: 0 !important;
    margin-top: 16px !important;

    .each-slideshow-indicator:before {
        background: #006400 !important;
    }
   }
`;

const Title = styled.div`
padding: 8px 12px;
	margin-bottom: 16px;
	background: linear-gradient(90deg, rgba(255, 214, 71, 0.00) 0%, #FFD647 50%, rgba(255, 214, 71, 0.00) 100%);
	backdrop-filter: blur(25px);

	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	color: #006400;
	text-align: center;
`;

const SampleSlide = ({
    active_topup_screenshot,
    receiving_account,
}) => {
    const { t } = useTranslation();

    return (
        <Container>
            <Title>{t("wallet.howto")}</Title>
            {((!active_topup_screenshot && receiving_account?.payment_category_view_sample_images?.length > 0) ||
                (active_topup_screenshot && receiving_account?.payment_category_view_topup_images?.length > 0))
                && (
                    <Slide
                        arrows={false}
                        autoplay={true}
                        indicators={true}
                        duration={3000}
                        transitionDuration={500}
                    >
                        {active_topup_screenshot
                            ? receiving_account?.payment_category_view_topup_images?.map(
                                (image, key) => (
                                    <SlideImage key={key} src={image} />
                                )
                            )
                            : receiving_account?.payment_category_view_sample_images?.map(
                                (image, key) => (
                                    <SlideImage key={key} src={image} />
                                )
                            )}
                    </Slide>
                )}
        </Container>
    )
}

export default SampleSlide